import React, { useEffect, useRef } from "react";
import classes from "./TopFour.module.css";
import Container from "../../UI/Container/Container";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const TopFour = (props) => {
  gsap.registerPlugin(ScrollTrigger);

  const containerRef = useRef(null);
  const firstItemRef = useRef(null);
  const secondItemRef = useRef(null);
  const thirdItemRef = useRef(null);
  const fourthItemRef = useRef(null);

  useEffect(() => {
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: containerRef.current,
        start: "top 50%",
      },
    });

    timeline.to(firstItemRef.current, {
      transform: "translateX(0)",
      opacity: 1,
      duration: 0.5,
      ease: "power4.in",
    });
    timeline.to(secondItemRef.current, {
      transform: "translateX(0)",
      opacity: 1,
      duration: 0.5,
      ease: "power4.in",
    });
    timeline.to(thirdItemRef.current, {
      transform: "translateX(0)",
      opacity: 1,
      duration: 0.5,
      ease: "power4.in",
    });
    timeline.to(fourthItemRef.current, {
      transform: "translateX(0)",
      opacity: 1,
      duration: 0.5,
      ease: "power4.in",
    });
  });

  return (
    <div ref={containerRef} className={classes.TopFour}>
      <Container>
        <div className={classes.TopFourContent}>
          <div className={classes.Column}>
            <h2>
              Top <span>4</span> ways our students and faculty connect
            </h2>
          </div>
          <div className={classes.Column}>
            <ol>
              <li ref={firstItemRef}>
                In the classroom (obviously)—our small classes and
                discussion-based approach mean your professor will know your
                name, and what sport you play, club you’re in, etc.
              </li>
              <li ref={secondItemRef}>Office hours and an open-door policy</li>
              <li ref={thirdItemRef}>
                Interaction spaces, where students and faculty can connect,
                study and work together
              </li>
              <li ref={fourthItemRef}>
                Over meals, whether in the dining hall, a restaurant downtown or
                a professor’s home
              </li>
            </ol>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default TopFour;
